import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { Fragment, useCallback, useState } from 'react';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';

import { createRender } from './types';

export const render = createRender(({ onDismissed, messageInstanceId }) => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const [isOpen, setIsOpen] = useState(true);
	const closeModal = useCallback(() => {
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'dismiss',
				clickedElement: 'button',
				buttonType: 'secondary',
			},
			action: { actionType: 'dismiss' },
			additionalMetadataFromFrontend: {},
		});
		onDismissed(messageInstanceId);
		setIsOpen(false);
	}, [onDismissed, messageInstanceId]);

	return (
		<Fragment>
			<ModalTransition>
				{isOpen && (
					<Modal onClose={closeModal}>
						<ModalHeader hasCloseButton>
							<ModalTitle>'Work' is the new term for items tracked in Jira</ModalTitle>
						</ModalHeader>
						<ModalBody>
							We're also improving how we incorporate the terms you use to define work, so that Jira
							speaks your language — no matter what you're working on.
						</ModalBody>
						<ModalFooter>
							{/* TODO: Need to add links */}
							<Button appearance="primary" onClick={closeModal}>
								OK
							</Button>
							<Button appearance="subtle" onClick={closeModal}>
								Read more
							</Button>
						</ModalFooter>
					</Modal>
				)}
			</ModalTransition>
		</Fragment>
	);
});

export default render;
